import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { ProductSubcategoriesCategory } from '../../types';

@Component({
    selector: 'dp-product-subcategory',
    templateUrl: './product-subcategory.component.html',
    styleUrl: './product-subcategory.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DpProductSubcategoryComponent {
  category = input.required<ProductSubcategoriesCategory>();
}
